import { createSlice } from "@reduxjs/toolkit";
import { getFromServerTopic } from "../utility/slice";

const SLICE = "urjanet";

export const getChargeUnit = getFromServerTopic({
  topic: SLICE,
  action: "getChargeUnit",
  payloadFn: async (payload) => {
    return payload;
  },
});

export const getUtilityABBRInformation = getFromServerTopic({
  topic: SLICE,
  action: "getUtilityABBRInformation",
  payloadFn: async (payload) => {
    return payload;
  },
});

export const setTariffOptions = getFromServerTopic({
  topic: SLICE,
  action: "getTariffOptions",
  payloadFn: async (payload) => {
    return payload;
  },
});

export const findBillrecordMappingByAccountId = getFromServerTopic({
  topic: SLICE,
  action: "findBillrecordMappingByAccountId",
  payloadFn: async (payload) => {
    return payload;
  },
});

export const findBillrecordMappingBySiteId = getFromServerTopic({
  topic: SLICE,
  action: "findBillrecordMappingBySiteId",
  contextOptionsFn: async ({ payload }) => payload,
  payloadFn: async (payload) => payload,
});

export const findBillrecordByAccountId = getFromServerTopic({
  topic: SLICE,
  action: "findBillrecordByAccountId",
  contextOptionsFn: async ({ payload }) => payload,
  payloadFn: async (payload) => payload,
});

export const getBillUnits = getFromServerTopic({
  topic: SLICE,
  action: "getBillUnits",
  contextOptionsFn: async ({ payload }) => payload,
  payloadFn: async (payload) => payload,
});

export const addBillrecordMapping = getFromServerTopic({
  topic: SLICE,
  action: "addBillrecordMapping",
  contextOptionsFn: async ({ payload }) => payload,
  payloadFn: async (payload) => payload,
});

export const deleteBillrecordMapping = getFromServerTopic({
  topic: SLICE,
  action: "deleteBillrecordMapping",
  contextOptionsFn: async ({ payload }) => payload,
  payloadFn: async (payload) => payload,
});

export const updateBillrecordMapping = getFromServerTopic({
  topic: SLICE,
  action: "updateBillrecordMapping",
  contextOptionsFn: async ({ payload }) => payload,
  payloadFn: async (payload) => payload,
});

export const addBillrecord = getFromServerTopic({
  topic: SLICE,
  action: "addBillrecord",
  contextOptionsFn: async ({ payload }) => payload,
  payloadFn: async (payload) => payload,
});

export const deleteBillrecord = getFromServerTopic({
  topic: SLICE,
  action: "deleteBillrecord",
  contextOptionsFn: async ({ payload }) => payload,
  payloadFn: async (payload) => payload,
});

export const updateBillrecord = getFromServerTopic({
  topic: SLICE,
  action: "updateBillrecord",
  contextOptionsFn: async ({ payload }) => payload,
  payloadFn: async (payload) => payload,
});

export const updateListOfBills = getFromServerTopic({
  topic: SLICE,
  action: "updateListOfBills",
  contextOptionsFn: async ({ payload }) => payload,
  payloadFn: async (payload) => payload,
});
export const findAllPdfFromAccountID = getFromServerTopic({
  topic: SLICE,
  action: "getAllPdfFromAccountID",
  contextOptionsFn: async ({ payload }) => payload,
  payloadFn: async (payload) => payload,
});

export const findAllBillRecordIdsFromAccount = getFromServerTopic({
  topic: SLICE,
  action: "getAllBillRecordIdsFromAccount",
  contextOptionsFn: async ({ payload }) => payload,
  payloadFn: async (payload) => payload,
});

export const uploadNewPDFs = getFromServerTopic({
  topic: SLICE,
  action: "uploadNewPDFs",
  contextOptionsFn: async ({ payload }) => {
    const { file, ...rest } = payload;
    return rest;
  },
  payloadFn: async (payload) => payload,
});

export const uploadPDFToExistingBill = getFromServerTopic({
  topic: SLICE,
  action: "uploadPDFToExistingBill",
  contextOptionsFn: async ({ payload }) => {
    const { file, ...rest } = payload;
    return rest;
  },
  payloadFn: async (payload) => payload,
});

export const fetchPDF = getFromServerTopic({
  topic: SLICE,
  action: "fetchPDF",
  payloadFn: async (payload) => {
    return payload;
  },
});

export const sendPdfToEmail = getFromServerTopic({
  topic: SLICE,
  action: "sendPdfToEmail",
  contextOptionsFn: async ({ payload }) => payload,
  payloadFn: async (payload) => payload,
});

export const processPDF = getFromServerTopic({
  topic: SLICE,
  action: "processPDF",
  contextOptionsFn: async ({ payload }) => payload,
  payloadFn: async (payload) => payload,
});

export const getHistoryForBillRecord = getFromServerTopic({
  topic: SLICE,
  action: "getHistoryForBillRecord",
  contextOptionsFn: async ({ payload }) => payload,
  payloadFn: async (payload) => payload,
});

export const getServiceTypesBySiteId = getFromServerTopic({
  topic: SLICE,
  action: "getServiceTypesBySiteId",
  contextOptionsFn: async ({ payload }) => payload,
  payloadFn: async (payload) => payload,
});

export const getInfoForMergeAccounts = getFromServerTopic({
  topic: SLICE,
  action: "getInfoForMergeAccounts",
  // contextOptionsFn: async ({ payload }) => payload,
  payloadFn: async (payload) => payload,
});

export const mergeAccountBills = getFromServerTopic({
  topic: SLICE,
  action: "mergeAccountBills",
  // contextOptionsFn: async ({ payload }) => payload,
  payloadFn: async (payload) => payload,
});

export const getBillrecordMappingByMergedId = getFromServerTopic({
  topic: SLICE,
  action: "findBillrecordMappingByMergedId",
  contextOptionsFn: async ({ payload }) => payload,
  payloadFn: async (payload) => payload,
});

export const urjanetSlice = createSlice({
  name: SLICE,
  //get rid urjanetAccount
  initialState: {
    urjanetAccount: {
      tariff: [],
      urjanetData: [],
      utility: [],
      units: [],
      newBuildingData: {},
    },
    billUnits: [],
    admin: false,
  },
  reducers: {
    handleChangeAdmin: (state) => {
      state.admin = !state.admin;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(setTariffOptions.fulfilled, (state, action) => {
        state.urjanetAccount = {
          ...state.urjanetAccount,
          tariff: action.payload.response,
        };
      })
      .addCase(getUtilityABBRInformation.fulfilled, (state, action) => {
        state.urjanetAccount = {
          ...state.urjanetAccount,
          utility: action.payload.response,
        };
      })
      .addCase(getChargeUnit.fulfilled, (state, action) => {
        state.urjanetAccount = {
          ...state.urjanetAccount,
          units: action.payload.response,
        };
      })
      .addCase(findBillrecordMappingBySiteId.fulfilled, (state, action) => {
        if (action.payload) {
          state.urjanetAccount.newBuildingData[`${action.meta.arg.site_id}`] = {
            ...state.urjanetAccount.newBuildingData[
              `${action.meta.arg.site_id}`
            ],
            utilityAccounts: action.payload.response,
          };
        }
      })
      .addCase(getServiceTypesBySiteId.fulfilled, (state, action) => {
        if (action.payload) {
          state.urjanetAccount.newBuildingData[`${action.meta.arg}`] = {
            ...state.urjanetAccount.newBuildingData[`${action.meta.arg}`],
            serviceTypes: action.payload.response,
          };
        }
      })
      .addCase(getBillUnits.fulfilled, (state, action) => {
        state.billUnits = [...action.payload.response];
      })
      .addCase(findBillrecordByAccountId.fulfilled, (state, action) => {
        state.urjanetAccount.newBuildingData[`${action.meta.arg.site_id}`] = {
          ...state.urjanetAccount.newBuildingData[`${action.meta.arg.site_id}`],
          utilityInfo: {
            ...state.urjanetAccount.newBuildingData[
              `${action.meta.arg.site_id}`
            ].utilityInfo,
            [`${action.meta.arg.account_id}`]: action.payload.response,
          },
        };
      });
  },
});

export const { handleChangeAdmin } = urjanetSlice.actions;
export default urjanetSlice.reducer;
